import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import moment from 'moment-timezone';
import onClickOutside from 'react-onclickoutside';
import { Link } from 'react-router';
import Dotdotdot from 'react-dotdotdot';
import { translate } from 'react-i18next';
import { changeCurrentInfoEvent } from '../../Messages/actions';

const EVENT_GROUPS = ['Alarm', 'Technical', 'Information', 'Logistic'];

const EVENT_TYPE_TO_CLASSNAME_MAP = {
  Alarm: 'triangle',
  Technical: 'hexagon',
  Information: 'circle',
  Logistic: 'circle',
};

@translate(['header'], { wait: true })
@onClickOutside
class InfoEvents extends Component {
  constructor(props) {
    super(props);

    this.state = {
      noticesOpened: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleClickOutside() {
    this.setState({
      noticesOpened: false,
    });
  }

  render() {
    const { t, unreadEventsCount } = this.props;
    const hasUnreadMessages = unreadEventsCount > 0;

    return (
      <li className={cx('has-submenu', { active: this.state.noticesOpened })}>
        <a
          href=""
          onClick={e => {
            e.preventDefault();
            this.setState({
              noticesOpened: !this.state.noticesOpened,
            });
          }}
        >
          <span className="icon icon-notice" />
          {hasUnreadMessages ? (
            <span className="num">
              {unreadEventsCount > 99 ? '99+' : unreadEventsCount}
            </span>
          ) : null}
        </a>
        <div className="header__nav__submenu">
          {this.props.infoEvents.length === 0 ? (
            <div className="header__nav__empty">
              <span className="icon icon-notice" />
              <h3>{t('header:no_notifications')}</h3>
              <p>{t('header:no_notifications_description')}</p>
            </div>
          ) : (
            <div>
              <div className="header__scroll__holder">
                {this.props.infoEvents.map(infoEvent => {
                  const iconClassName = cx(
                    'ico',
                    `icon_notice_${
                      EVENT_TYPE_TO_CLASSNAME_MAP[EVENT_GROUPS[infoEvent.group]]
                    }`,
                    { icon_notice_opacity: infoEvent.isRead },
                  );
                  const time =
                    moment().diff(moment(infoEvent.created * 1000), 'days') ===
                    0
                      ? moment(infoEvent.created * 1000).format('HH:mm')
                      : moment(infoEvent.created * 1000).format('DD/MM');

                  return (
                    <div
                      key={infoEvent.id}
                      className="header__nav__submenu__item"
                    >
                      <Link
                        onClick={() => {
                          this.setState({ noticesOpened: false });
                          this.props.changeInfoEvent(infoEvent);
                        }}
                        to="/messages"
                        className="link"
                      />
                      <div className="header__nav__submenu__item__notice">
                        <span className={iconClassName} />
                        <div className="time">{time}</div>
                        <Dotdotdot clamp={2} className="holder">
                          <div className="title">{infoEvent.header}</div>
                          <p>{infoEvent.text}</p>
                        </Dotdotdot>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="header__nav__submenu__more align-center">
                <Link
                  onClick={() => {
                    this.setState({ noticesOpened: false });
                  }}
                  className="more"
                  to="/messages"
                >
                  {t('header:all_notifications')}
                  <i className="icon-arrow-right" />
                </Link>
              </div>
            </div>
          )}
        </div>
      </li>
    );
  }
}

InfoEvents.WrappedComponent.propTypes = {
  infoEvents: PropTypes.arrayOf(PropTypes.object).isRequired,
  unreadEventsCount: PropTypes.number.isRequired,
  changeInfoEvent: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    infoEvents: state.infoEvents.notificationInfoEvents.slice(0, 3),
    unreadEventsCount: state.infoEvents.unreadEventsCount,
  }),
  dispatch => ({
    changeInfoEvent(infoEvent) {
      dispatch(changeCurrentInfoEvent({ infoEvent }));
    },
  }),
)(InfoEvents);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderRightNav/InfoEvents.js